import { useMutation, useQueryClient } from "@tanstack/react-query";

import { saveModelOverride } from "./api";
import type { Role } from "./api";

// Сохранение ручного override модели
// (source=manual, edited_by=principal на backend). На успех инвалидируем
// весь префикс `agent-roles` — detail роли (новый effective_model) и
// общая история override'ов (новая строка override'а) перечитаются.
// Ошибку (404 нет роли / 422 модель не из провайдера) пробрасываем для
// тоста.
interface SaveModelOverrideArgs {
  readonly roleName: string;
  readonly model: string;
}

export function useSaveModelOverride(): ReturnType<
  typeof useMutation<Role, Error, SaveModelOverrideArgs>
> {
  const queryClient = useQueryClient();
  return useMutation<Role, Error, SaveModelOverrideArgs>({
    mutationFn: (args) => saveModelOverride(args.roleName, args.model),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["agent-roles"] });
    },
  });
}
